import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { BatchOrderUserInfoInput } from './BatchOrderUserInfoInput';
import { BatchOrderUserInfoOutput } from './BatchOrderUserInfoOutput';

export class BatchOrderUserInfoService extends HttpServiceBase {

  getUsersCreatedBatches = (input: BatchOrderUserInfoInput): Promise<Result<BatchOrderUserInfoOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<BatchOrderUserInfoOutput>>(`${this.baseUrlSislogApi}/v2/order/batch/users/created${parameters}`);
    return promise;
  }

  getUsersUpdatedBatches = (input: BatchOrderUserInfoInput): Promise<Result<BatchOrderUserInfoOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<BatchOrderUserInfoOutput>>(`${this.baseUrlSislogApi}/v2/order/batch/users/updated${parameters}`);
    return promise;
  }
}